import NextLink from 'next/link';

import {Button, Text} from '#component/base';
import {AuthCTAMessages} from '#component/partial';

/**
 * `VerifySuccess` is the screen shown when the user has successfully verified
 * their account, and may be conditionally rendered by the `VerifyAccount` and
 * `VerifyPending` page components.
 */
export const VerifySuccess = ({authenticated = false}) => (
  <>
    <AuthCTAMessages
      title="You’re verified!"
      messages={[
        <div key={1}>
          <Text as="p" color="doveGray">
            Thank you for verifying your email.
          </Text>

          <Text as="p" color="doveGray">
            {authenticated
              ? 'You can now proceed to your dashboard.'
              : 'You can log into your account now.'}
          </Text>
        </div>,
      ]}
    />

    <NextLink href={authenticated ? '/dashboard' : '/signin'} passHref>
      <Button as="a" icon="ArrowRight">
        {authenticated ? 'View dashboard' : 'Log in'}
      </Button>
    </NextLink>
  </>
);
